import { sqliteTable, text, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// supplier_contacts — ช่องทางติดต่อผู้จำหน่าย (purchase-owned child table)
// ============================================================================
export const supplierContacts = sqliteTable("purchase_supplier_contacts", {
  id: text("id").primaryKey(), // ULID; preserved from accounting_partner_contacts during backfill
  supplierId: text("supplier_id").notNull(),
  channelId: text("channel_id").notNull(),
  contactValue: text("contact_value").notNull(),
  isPrimary: integer("is_primary").notNull().default(0),
  notes: text("notes"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  supplierIdx: index("purchase_supplier_contact_supplier_idx").on(table.supplierId),
  supplierDeletedIdx: index("purchase_supplier_contact_supplier_deleted_idx").on(
    table.supplierId,
    table.deletedAt,
  ),
}));

export type SupplierContact = typeof supplierContacts.$inferSelect;
export type NewSupplierContact = typeof supplierContacts.$inferInsert;
